/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

// Scrollbar Start
class SliderScrollbar {
  constructor(slider) {
    this.slider = slider;
    this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.init();
    window.addEventListener('resize', () => this.handleResize());
  }

  handleResize() {
    const newIsMobile = window.matchMedia('(max-width: 767px)').matches;
    if (newIsMobile !== this.isMobile) {
      this.isMobile = newIsMobile;
      this.recreateScrollbar();
    }
  }

  recreateScrollbar() {
    const existing = this.slider.parentNode.querySelector('.scrollbar-wrapper');
    if (existing) existing.remove();
    this.createScrollbar();
  }

  init() {
    this.createScrollbar();
  }

  createScrollbar() {
    const scrollbarWrap = document.createElement('div');
    scrollbarWrap.className = 'scrollbar-wrapper';

    const scrollbar = document.createElement('div');
    scrollbar.className = 'slider-scrollbar';

    const thumb = document.createElement('div');
    thumb.className = 'slider-scrollbar__thumb';

    scrollbar.appendChild(thumb);
    scrollbarWrap.appendChild(scrollbar);

    this.slider.parentNode.insertBefore(scrollbarWrap, this.slider.nextSibling);

    // Update thumb on scroll
    this.slider.addEventListener('scroll', () => {
      this.updateThumb(thumb);
    });

    // Click anywhere on scrollbar to jump
    scrollbar.addEventListener('click', (e) => {
      this.handleScrollbarClick(e, scrollbar);
    });

    this.updateThumb(thumb);
  }

  updateThumb(thumb) {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    if (maxScroll <= 0) {
      thumb.style.width = "100%";
      thumb.style.left = "0%";
      return;
    }

    // Calculate thumb width (proportional to visible area)
    const thumbWidth = (this.slider.clientWidth / this.slider.scrollWidth) * 100;
    thumb.style.width = `${Math.max(10, thumbWidth)}%`; // Minimum 10% width

    // Calculate thumb position
    const scrollRatio = this.slider.scrollLeft / maxScroll;
    const maxThumbPosition = 100 - thumbWidth;
    const thumbPosition = scrollRatio * maxThumbPosition;
    
    thumb.style.left = `${thumbPosition}%`;
  }

  handleScrollbarClick(e, scrollbar) {
    const rect = scrollbar.getBoundingClientRect();
    const clickRatio = (e.clientX - rect.left) / rect.width;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    this.slider.scrollTo({
      left: clickRatio * maxScroll,
      behavior: 'smooth'
    });
  }
}

function initRecommendationSliders(context = document) {
  context.querySelectorAll('.grid--slider[data-custom-dots="true"], .grid--mobile-slider[data-custom-dots="true"]').forEach((el) => {
    if (!el.dataset.sliderInit) {
      new SliderScrollbar(el);
      el.dataset.sliderInit = "true";
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initRecommendationSliders();

  setTimeout(() => {
    const recentProductsSection = document.querySelector('.recent__content[data-grid-slider]');
    if (recentProductsSection) {
      initRecommendationSliders();
      console.log("Reinit recommended section!");
    }
  }, 2000);
});

document.addEventListener("shopify:section:load", (e) => {
  initRecommendationSliders(e.target);
});
// end Scrollbar


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sliderow__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const wrapper = this.closest(".sliderow-wrap");
      if (wrapper) {
        wrapper.classList.toggle("open");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".product__slide[data-image-id]");
  const thumbs = document.querySelectorAll(".product__thumb[data-thumb-item]");

  if (!slides.length || !thumbs.length) return;

  const setActiveThumb = (imageId) => {
    thumbs.forEach((thumb) => {
      const thumbLink = thumb.querySelector("[data-media-id]");
      if (thumbLink && thumbLink.getAttribute("data-media-id").includes(imageId)) {
        thumb.classList.add("is-active");
      } else {
        thumb.classList.remove("is-active");
      }
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const imageId = entry.target.getAttribute("data-image-id");
          setActiveThumb(imageId);
        }
      });
    },
    {
      root: null,
      threshold: 0.6,
    }
  );

  slides.forEach((slide) => observer.observe(slide));
});
})();

document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll('.video-mute-toggle');

  toggleButtons.forEach((button) => {
    // Prevent Flickity drag capture
    button.addEventListener('pointerdown', e => e.stopPropagation());
    button.addEventListener('touchstart', e => e.stopPropagation());

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const videoId = this.dataset.videoId;
      const video = document.getElementById(videoId);
      if (!video) return;

      video.muted = !video.muted;
      this.classList.toggle('is-muted', video.muted);
    });
  });
});
